import apiClient from "@/shared/api/apiClient3";

export const getDirectoryTree = async (params = {}) => {
  try {
    const { data } = await apiClient.get("/directory/categories", {
      params,
      metaData: { isNotificationDisabled: true },
    });
    return data;
  } catch (e) {
    console.error("Ошибка загрузки дерева каталогов:", e);
    throw e;
  }
};

export const getDirectoryList = async (params = {}) => {
  try {
    const { data } = await apiClient.get("/directory", {
      params,
      metaData: { isNotificationDisabled: true },
    });
    return data;
  } catch (e) {
    console.error("Ошибка загрузки справочника:", e);
    throw e;
  }
};

export const getDirectoryItem = async (code, params) => {
  try {
    const { data } = await apiClient.get(`/directory/${code}`, {
      params,
    });
    return data;
  } catch (e) {
    console.error(`Ошибка загрузки элемента ${code}:`, e);
    throw e;
  }
};

export const getDirectoryChildren = async (code, params = {}) => {
  try {
    const { data } = await apiClient.get(`/directory/${code}/values`, {
      params,
      metaData: { isNotificationDisabled: true },
    });
    return data;
  } catch (e) {
    console.error(`Ошибка загрузки детей элемента ${code}:`, e);
    throw e;
  }
};

export const getDirectoryByParentAllChildren = async (parent_code, params) => {
  try {
    const { data } = await apiClient.get(`/directory/${parent_code}/children`, {
      params,
      metaData: { isNotificationDisabled: true },
    });
    return data;
  } catch (e) {
    console.error(`Ошибка загрузки все потомки элемента ${parent_code}:`, e);
    throw e;
  }
};

export const createDirectoryItem = async (params) => {
  try {
    const result = await apiClient.post("/directory/", params);
    return result.data;
  } catch (e) {
    console.error("Ошибка создания элемента:", e);
    throw e;
  }
};

export const updateDirectoryItem = async (code, params) => {
  try {
    const result = await apiClient.patch(`/directory/${code}`, params);
    return result.data;
  } catch (e) {
    console.error(`Ошибка обновления элемента ${code}:`, e);
    throw e;
  }
};

export const deleteDirectoryItem = async (code) => {
  try {
    const result = await apiClient.delete(`/directory/${code}`);
    return result.data;
  } catch (e) {
    console.error(`Ошибка удаления элемента ${code}:`, e);
    throw e;
  }
};

export const addDirectoryChild = async (parentCode, childCode) => {
  try {
    const result = await apiClient.post(
      `/directory/${parentCode}/children/${childCode}`,
      {},
      { metaData: { isNotificationDisabled: true } }
    );
    return result.data;
  } catch (e) {
    console.error(`Ошибка добавления ребенка ${childCode} к ${parentCode}:`, e);
    throw e;
  }
};

export const replaceDirectoryChildren = async (parentCode, codes) => {
  try {
    const result = await apiClient.put(`/directory/${parentCode}/children`, {
      codes,
    });
    return result.data;
  } catch (e) {
    console.error(`Ошибка замены детей элемента ${parentCode}:`, e);
    throw e;
  }
};

export const getDirectoryItemsByCodes = async (codes) => {
  try {
    const { data } = await apiClient.post(
      "/directory/batch/",
      {
        ...codes,
      },
      {
        metaData: { isNotificationDisabled: true },
      }
    );
    return data;
  } catch (e) {
    console.error("Ошибка массовой загрузки элементов:", e);
    throw e;
  }
};

export const searchDirectoryItems = async (params = {}) => {
  try {
    const { data } = await apiClient.get("/directory/", {
      params,
      metaData: { isNotificationDisabled: true },
    });
    return data;
  } catch (e) {
    console.error("Ошибка поиска по справочнику:", e);
    throw e;
  }
};
